'use client';
import React from 'react';

export default function TrustBadgesBar() {
  return (
    <div className="relative z-10 max-w-[1170px] mx-auto px-4 mt-8 lg:mt-12 mb-14">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-7">
        {[
          {
            title: 'Safe & Secure Bookings',
            desc: 'PCI-DSS compliant encrypted transactions.',
            icon: (
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                <path d="m9 11 2 2 4-4" />
              </svg>
            ),
            bg: 'bg-emerald-50 text-emerald-600 border-emerald-100/60',
            glow: 'hover:shadow-[0_8px_30px_rgba(16,185,129,0.08)] hover:border-emerald-300',
          },
          {
            title: '24/7 Customer Support',
            desc: 'Always active support line for booking assistance.',
            icon: (
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
              </svg>
            ),
            bg: 'bg-accent/10 text-accent border-accent/20',
            glow: 'hover:shadow-[0_8px_30px_rgba(0,98,227,0.08)] hover:border-accent/40',
          },
          {
            title: 'Deals from 500+ Airlines',
            desc: 'Direct unpublished ticketing relationships.',
            icon: (
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M17.8 19.2L16 11l3.5-3.5C21 6 21.5 4 21 3.5c-.5-.5-2.5 0-4 1.5L13.5 8.5l-8.2-1.8-1.8 1.8 7 4.2-3.5 3.5-3-1-1.5 1.5 4.5 2.5 2.5 4.5 1.5-1.5-1-3 3.5-3.5 4.2 7 1.8-1.8z" />
              </svg>
            ),
            bg: 'bg-sky-50 text-sky-600 border-sky-100/60',
            glow: 'hover:shadow-[0_8px_30px_rgba(56,189,248,0.08)] hover:border-sky-300',
          },
        ].map((badge, i) => (
          <div
            key={i}
            className={`flex items-center gap-4 bg-white border border-slate-100 p-5 rounded-2xl shadow-[0_4px_20px_rgba(0,0,0,0.02)] transition-all duration-300 hover:-translate-y-1 ${badge.glow}`}
          >
            <div
              className={`w-12 h-12 rounded-xl flex items-center justify-center border ${badge.bg}`}
            >
              {badge.icon}
            </div>
            <div>
              <h3 className="font-extrabold text-slate-800 text-sm leading-snug">{badge.title}</h3>
              <p className="text-[11px] text-slate-500 font-semibold mt-1">{badge.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
